import { render } from "./GuardianEdit.vue?vue&type=template&id=01b8eb52&scoped=true&ts=true"
import script from "./GuardianEdit.vue?vue&type=script&lang=ts"
export * from "./GuardianEdit.vue?vue&type=script&lang=ts"

import "./GuardianEdit.vue?vue&type=style&index=0&id=01b8eb52&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b8eb52"]])

export default __exports__